import React from "react"
import { connect } from "react-redux"

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from "react-router-dom"
import { Radio, Input, Alert } from "antd"
import { bindActionCreators } from "redux"
import { Select, Switch, Button, Form, Modal, Tooltip } from "antd"
import Card, { TitleCard, CardHeader } from "../../core/Card"
import { DatePicker, message } from "antd"
import {
  FromToIcon,
  PlusIcon,
  CrownIcon,
  BriefcaseIcon,
  MarkerIcon,
  ForwardIcon,
  HomeIcon,
  DotIcon,
  BackIcon
} from "../../core/icons"
import { Collapse } from "antd"

import { submit, reduxForm, Field, FieldArray } from "redux-form"
import { push, goBack } from "react-router-redux"
import moment from "moment"
import { LocaleProvider } from "antd"
import enUS from "antd/lib/locale-provider/en_US"
import {
  generateReport,
  handleRemoteSubmit,
  remoteSubmit,
  setAdvancedFilter,
  changeIntegrations
} from "./actions"
import "./DataExport.css"
import Integrations from "../integrations/Integrations"
import makeField from "../makeField"
const { MonthPicker, RangePicker } = DatePicker
const Option = Select.Option

const AInput = makeField(Input)
const ASwitch = makeField(Switch)
const ASelect = makeField(Select)
const rangePickerRanges = {
  Today: [moment(), moment()],
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "Last Month": [
    moment()
      .subtract(1, "month")
      .startOf("month"),
    moment()
      .subtract(1, "month")
      .endOf("month")
  ],
  "This Year": [moment().startOf("year"), moment().endOf("year")],
  "Last Year": [
    moment()
      .subtract(1, "year")
      .startOf("year"),
    moment()
      .subtract(1, "year")
      .endOf("year")
  ]
}

// NOTE the only diff from makeField is that is not wrapped with FormItem
const ARangePicker = ({
  input,
  meta,
  children,
  hasFeedback,
  label,
  ...rest
}) => {
  const hasError = meta.invalid
  // const hasError = meta.touched && meta.invalid;
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  }
  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      validateStatus={hasError ? "error" : "success"}
      hasFeedback={hasFeedback && hasError}
      help={hasError && meta.error}
    >
      <RangePicker
        ranges={rangePickerRanges}
        className={hasError ? "has-error" : null}
        format={"MM/DD/YYYY"}
        {...input}
        {...rest}
        style={{ width: "50%" }}
      />
    </Form.Item>
  )
}

const AdditionalRecipients = () => (
  <Card className="AdditionalRecipients">
    <FieldArray
      name="additional_recipients"
      component={({ fields, meta: { error, submitFailed } }) => (
        <ul>
          <li>
            <h2>
              Additional Recipients
              <Button type="button" onClick={() => fields.push("")}>
                Add Recipient
              </Button>
              {submitFailed && error && <span>{error}</span>}
            </h2>
          </li>
          {fields.map((recipient, index) => (
            <li key={index}>
              <Field
                name={`${recipient}`}
                type="text"
                component={AInput}
                label="Recipient"
              />
            </li>
          ))}
        </ul>
      )}
    />
  </Card>
)

const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? "Invalid email address"
    : undefined
const required = value => (value ? undefined : "Required")

const AdditionalRecipient = ({ showEmailInput }) => (
  <Card className="AdditionalRecipient">
    <CardHeader title="Who do you send your reports to?" />

    <Field
      label="Recipient"
      name="type"
      component={ASelect}
      style={{ width: "50%" }}
      type="input"
      validate={required}
      placeholder="Select who to send to..."
    >
      <option value="InviteManager">
        My company (manager, accounting, etc)
      </option>
      <option value="InviteAccountant">
        My Tax Pro (tax preparer, bookkeeper, etc)
      </option>
      <option value="self">Nobody, just me</option>
    </Field>
    {showEmailInput && (
      <Field
        name="email"
        style={{ width: "50%" }}
        type="text"
        component={AInput}
        label="Their email"
        validate={[email, required]}
      />
    )}
  </Card>
)

const BasicFilters = () => (
  <Card className="BasicFilters">
    <CardHeader title="Basic Filters" />
    <Field
      label="Dates"
      name="range"
      validate={[val => (val && val.length > 0 ? undefined : "Range is empty")]}
      component={ARangePicker}
    />
  </Card>
)

const AdvancedFilters = ({
  setAdvancedFilter,
  isPremium,
  purposes,
  income_sources
}) => (
  <Card className="AdvancedFilters">
    <CardHeader
      title={
        <Tooltip
          title={
            isPremium
              ? `Congrats! You can apply advanced filters with your premium membership.`
              : `Premium only filters. Upgrade today!`
          }
        >
          Advanced Filters
          <CrownIcon width="17" height="17" />
        </Tooltip>
      }
    />

    <Field
      label="Format"
      name="file_type"
      component={ASelect}
      style={{ width: "50%" }}
      type="input"
      onChange={setAdvancedFilter}
    >
      <option value="csv">Excel (CSV)</option>
      <option value="pdf">PDF</option>
      {/* <option value="email">Email</option> */}
    </Field>

    <Field
      label="Purpose"
      name="purpose"
      component={ASelect}
      style={{ width: "50%" }}
      onChange={setAdvancedFilter}
      type="input"
    >
      <option value="">All</option>
      {purposes.map(purpose => <option value={purpose}>{purpose}</option>)}
    </Field>

    <Field
      label="Business Line"
      name="income_source"
      component={ASelect}
      style={{ width: "50%" }}
      onChange={setAdvancedFilter}
      type="input"
    >
      <option value="">All</option>
      {income_sources.map(line => <option value={line}>{line}</option>)}
    </Field>

    <Field
      label="Export Type"
      name="entity"
      component={ASelect}
      style={{ width: "50%" }}
      onChange={setAdvancedFilter}
      type="input"
    >
      <option value="">All</option>
      <option value="trips">Trips</option>
      <option value="transactions">Transactions</option>
      <option value="expenses">Expenses</option>
      <option value="revenue">Revenue</option>
    </Field>
  </Card>
)

const DataExport = ({
  showInviteForm,
  showEmailInput,
  setAdvancedFilter,
  invalid,
  purposes,
  income_sources,
  isPremium,
  pristine,
  disabled,
  submitting,
  generateReport,
  remoteSubmit,
  userTokenId,
  integrations_enabled,
  integration_accounts,
  changeIntegrations,
  showIntegrationsModal
}) => (
  <div className="DataExport">
    <TitleCard showBackButton sticky>
      <h1>Create Data Export</h1>
      <Button loading={submitting} onClick={remoteSubmit} type="primary">
        Generate Export
      </Button>
    </TitleCard>

    {/* <AdditionalRecipients/> */}

    {showInviteForm && <AdditionalRecipient showEmailInput={showEmailInput} />}

    <BasicFilters />

    <AdvancedFilters
      isPremium={isPremium}
      purposes={purposes}
      income_sources={income_sources}
      setAdvancedFilter={setAdvancedFilter}
    />

    <Integrations
      onChange={changeIntegrations}
      // enabled={[...integrations_enabled, "xero"]}
      showIntegrationsModal={showIntegrationsModal}
      enabled={integrations_enabled}
    />
  </div>
)

const mapStateToProps = state => {
  const userBelongsToGroup =
    !!state.models.user.group_as_client ||
    !!state.models.user.group_as_enterprise_member

  return {
    ...state.account.dataExport,
    isPremium: state.models.user.isPremium,
    income_sources: state.models.user.income_sources,
    initialValues: state.account.dataExport,
    showEmailInput:
      state.form.dataExportForm &&
      state.form.dataExportForm.values &&
      state.form.dataExportForm.values.type &&
      state.form.dataExportForm.values.type != "self",
    showInviteForm: !userBelongsToGroup,
    purposes: [
      // 'All',
      "Work",
      "Unclassified",
      "Personal",
      "Medical",
      "Charity",
      "Moving",
      "Commute",
      "Other"
    ],
    integrations_enabled: state.models.user.integrations_enabled
  }
}

const mapDispatchToProps = dispatch => {
  return {
    remoteSubmit: () => dispatch(submit("dataExportForm")),
    showIntegrationsModal: () =>
      dispatch({
        type: "SHOW_MODAL",
        modalType: "INTEGRATIONS_MODAL",
        modalProps: {
          title: "Integrations",
          buttonText: "Done"
        }
      }),
    ...bindActionCreators({ setAdvancedFilter, changeIntegrations }, dispatch)
  }
}

const DataExportForm = reduxForm({
  form: "dataExportForm",
  onSubmit: (values, dispatch, ownProps) =>
    dispatch(generateReport(values))
      .then(() =>
        message.success(
          "Your Data Export is generating... It will be available here and emailed to you in a minute or two. ",
          10
        )
      )
      .then(
        () => dispatch(push("/data-exports")),
        error => console.log({ error })
      )
  // .then(dispatch({type:'SHOW_SHARE_MODAL'}))
  // .catch((error)=>{
  //   console.log({error})
  //   // message.warn('Unlock premium to be able to save your work hours.', 10)
  // })
})(DataExport)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataExportForm)



// WEBPACK FOOTER //
// ./src/account/data-export/DataExport.js